var render = function render(_c, _vm) {
  return typeof _vm.props.copyText !== "undefined"
    ? _c(
        "div",
        { staticClass: "truncated-text-copy", class: _vm.props.customClass },
        [
          _c(
            "div",
            {
              staticClass: "overflow-ellipsis truncated-text-copy__value",
              attrs: { title: _vm.props.title || _vm.props.copyText }
            },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          !_vm.props.hideCopyButton
            ? _c(
                "a",
                {
                  directives: [
                    {
                      name: "clipboard",
                      rawName: "v-clipboard",
                      value: { copyText: _vm.props.copyText },
                      expression: "{ copyText: props.copyText }"
                    },
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Copy",
                      expression: "'Copy'"
                    }
                  ],
                  staticClass:
                    "btn btn-link m-l-5 p-0 no_border truncated-text-copy__icon",
                  class: {
                    "truncated-text-copy__icon--visible":
                      _vm.props.alwaysShowCopyButton
                  },
                  attrs: { placement: _vm.placement }
                },
                [_c("i", { staticClass: "typcn typcn-tabs-outline" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("extras")
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }